import { ILCHttpResponse, IRolesAndPermissions } from '@logicalcommander/types'
import { createApi } from '@reduxjs/toolkit/query/react'
import { v4 as uuidv4 } from 'uuid'
import { configManager } from '../../config/configManager'
import { RootState } from '../redux/store'
import { createBaseQueryWithErrorHandling } from './baseQueryWithErrorHandling'

export const rolesApi = createApi({
  reducerPath: 'rolesApi',
  baseQuery: createBaseQueryWithErrorHandling(`${configManager.api.GATEWAY_URL}/role`, (headers, { getState }) => {
    headers.set('x-request-id', uuidv4())
    const { token, companyToken } = (getState() as RootState).authReducer
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    if (companyToken) {
      headers.set('x-company-token', companyToken)
    }
    return headers
  }),
  endpoints: (builder) => ({
    getRolesAndPermissions: builder.query<IRolesAndPermissions[], void>({
      query: () => {
        return {
          url: 'all',
        }
      },
      transformResponse: (rawResult: unknown) => {
        if (Array.isArray(rawResult)) return rawResult as IRolesAndPermissions[]
        const wrapped = rawResult as ILCHttpResponse<IRolesAndPermissions[]>
        return (wrapped?.data ?? []) as IRolesAndPermissions[]
      },
    }),
    getPermissionsByRole: builder.query<any, { roleName: string }>({
      query: ({ roleName }) => {
        return {
          url: `permissions/${roleName}`,
        }
      },
    }),
    addRole: builder.mutation<IRolesAndPermissions, { roleName: string }>({
      query: (body) => ({
        url: 'add',
        method: 'POST',
        body,
      }),
    }),
    deleteRole: builder.mutation<void, { roleName: string }>({
      query: ({ roleName }) => ({
        url: `/${roleName}`,
        method: 'DELETE',
      }),
    }),
  }),
})

export const { useLazyGetRolesAndPermissionsQuery, useLazyGetPermissionsByRoleQuery, useAddRoleMutation, useDeleteRoleMutation } = rolesApi
